<template>
    <div style="color: black;">
        <sweet-modal blocking ref="modalInfo" class="modal" v-on:close="rejectConfirmCloseInfoModal" >
            <h1 class="modal__title">Cash Advance Details</h1>
            <el-form :model="form" status-icon :rules="rules" ref="form" class="accountant-project-cash-advance-modal__form">
            <div class="modal__category">
                <div class="label">Cash Advance No.: {{cashAdvanceNoModal}}</div>
            </div>
            <div class="modal__name">
                <div class="label"><i class="el-icon-date"></i>{{cashAdvanceDateModal}}</div>
            </div>
            <div class="modal__category">
                <div class="label">Category: {{cashAdvanceInventoryItemModal}}</div>
            </div>
            <div class="modal__amount">
                <h3>Amount: {{formatPrice(cashAdvanceAmountModal)}}</h3>
                <div>
                    <el-tag v-if="cashAdvanceStatusModal" size="mini" class="tag" style="margin-right: 10px; width:100px; height:22px; text-align: center;" v-html="cashAdvanceStatusModal"></el-tag>
                    <!--<el-tag v-if="expenseReimbursableModal" size="mini" class="tag" style="margin-right: 10px; width:100px; height:22px; text-align: center;" v-html="expenseReimbursableModal"></el-tag>-->
                    <!--<el-tag v-if="expenseisBillableModal" size="mini" class="tag" style="width:100px; height:22px; text-align: center;" v-html="expenseisBillableModal"></el-tag>-->
                    <div class="modal__history_btn_block">
                        <el-button size="mini"
                                   type="primary"
                                   plain
                                   @click="$refs.historyModal.open()">History</el-button>
                    </div>
                </div>
            </div>
            <el-row :span="24" class="modal__bottom">
                <!--<el-col :span="12">-->
                    <!--<b>Vendor : </b><span>{{expenseVendorModal}}</span>-->
                <!--</el-col>-->
                <el-col :span="12">
                    <b>Client : </b><span>{{cashAdvanceClientModal}}</span>
                </el-col>
            </el-row>
            <!--BLOCK ABLE ONLY FOR ACCOUNTANT-->
            <el-row v-if="cashAdvanceStatusModal === 'Approved' && isAccountant" :span="24" class="modal__bottom">
                <b>Select Payment Method</b>
                <el-form-item prop="paymentMethodId">
                    <el-select v-model="form.paymentMethodId" size="mini" placeholder="Payment Method">
                        <el-option
                                v-for="item in form.paymentMethodList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-row>
            <el-row v-else :span="24" class="modal__bottom">
                <el-col :span="12">
                    <b>Payment Method : </b><span>{{cashAdvancePaymentMethodModal}}</span>
                </el-col>
                <!--<el-col :span="12">-->
                    <!--<b>Tax : </b><span>{{expenseTaxModal}}</span>-->
                <!--</el-col>-->
            </el-row>
            <el-row :span="24" class="modal__bottom">
                <el-col :span="12">
                    <b>Project : </b><span>{{cashAdvanceProjectModal}}</span>
                </el-col>
                <el-col :span="12">
                    <b>Task : </b><span>{{cashAdvanceProjectTaskModal}}</span>
                </el-col>
            </el-row>
            <el-row :span="24" class="modal__bottom">
                <el-col :span="12">
                    <b>Group / Trip Name : </b><span>{{cashAdvanceGroupModal}}</span>
                </el-col>
                <!--<el-col :span="12">-->
                    <!--<b>Vendor Tax Number: </b><span>{{expenseVendorTaxNumberModal}}</span>-->
                <!--</el-col>-->
            </el-row>
            <el-row v-if="cashAdvanceFileModal" class="modal__bottom">
                <el-col :span="20">
                    <div><b>File : </b>{{cashAdvanceFileModal.baseName}}</div>
                </el-col>
                <el-col :span="4">
                    <el-button @click="viewFile(cashAdvanceFileModal.url)" type="warning" icon="el-icon-view" size="mini" plain></el-button>
                </el-col>
            </el-row>
            <el-row :span="24" class="modal__bottom">
                <b>Notes: </b><span>{{cashAdvanceNotesModal}}</span>
            </el-row>
            <!--BLOCK ABLE ONLY FOR LEADER-->
            <div v-if="cashAdvanceStatusModal === 'Submited' && isLeader">
                <el-row :span="24" class="modal__bottom">
                    <el-button
                            size="mini"
                            type="success"
                            plain
                            @click="handleApprove(activeCompanyId, activeProjectId, activeTaskId, activeCashAdvanceId, state)">Approve</el-button>
                    <el-button
                            size="mini"
                            type="danger"
                            plain
                            @click="$refs.rejectConfirm.open()">Reject</el-button>
                </el-row>
            </div>
            <!--BLOCK ABLE ONLY FOR ACCOUNTANT-->
            <div v-if="cashAdvanceStatusModal === 'Approved' && isAccountant">
                <el-row :span="24" class="modal__bottom">
                    <el-button
                            size="mini"
                            type="success"
                            plain
                            @click="handleDeposit(activeCompanyId, activeProjectId, activeTaskId, activeCashAdvanceId, state)">Deposit</el-button>
                </el-row>
            </div>
            <!--RECEIVED BLOCK-->
            <div v-if="cashAdvanceStatusModal === 'Deposit'">
                <el-row :span="24" class="modal__bottom">
                    <el-button
                              size="mini"
                              type="success"
                              plain
                              @click="handleReceive(activeCompanyId, activeProjectId, activeTaskId, activeCashAdvanceId, state)">Receive</el-button>
                </el-row>
            </div>
            </el-form>
        </sweet-modal>
        <sweet-modal blocking ref="historyModal">
            <h3>History</h3>
            <div class="history-block">
                <div v-if="projectTaskCashAdvanceHistoryList.length > 0">
                    <div v-for="item in projectTaskCashAdvanceHistoryList" :key="item.id" :span="24">
                        <div class="history-item-block" v-if="item.action === 'rejectProjectTaskCashAdvance' || item.action === 'rejectProjectTaskCashAdvanceRequest'">
                            <el-row>
                                <el-col :span="6">
                                    <el-tag type="danger" size="small">Rejected</el-tag>
                                </el-col>
                                <el-col :span="10">
                                    {{moment(item.createDate.toString(), 'X').format('lll')}}
                                </el-col>
                            </el-row>
                            <el-row>
                                <b>Reason:</b><br>
                                {{item.params.description}}
                            </el-row>
                        </div>
                        <div class="history-item-block" v-if="item.action === 'createProjectTaskCashAdvance' || item.action === 'createProjectTaskCashAdvanceRequest'">
                            <el-row>
                                <el-col :span="6">
                                    <el-tag size="small">Created</el-tag>
                                </el-col>
                                <el-col :span="10">
                                    {{moment(item.createDate.toString(), 'X').format('lll')}}
                                </el-col>
                            </el-row>
                        </div>
                        <div class="history-item-block" v-if="item.action === 'submitProjectTaskCashAdvance' || item.action === 'submitProjectTaskCashAdvanceRequest'">
                            <el-row>
                                <el-col :span="6">
                                    <el-tag size="small">Submited</el-tag>
                                </el-col>
                                <el-col :span="10">
                                    {{moment(item.createDate.toString(), 'X').format('lll')}}
                                </el-col>
                            </el-row>
                        </div>
                        <div class="history-item-block" v-if="item.action === 'approveProjectTaskCashAdvance' || item.action === 'approveProjectTaskCashAdvanceRequest'">
                            <el-row>
                                <el-col :span="6">
                                    <el-tag type="success" size="small">Approved</el-tag>
                                </el-col>
                                <el-col :span="10">
                                    {{moment(item.createDate.toString(), 'X').format('lll')}}
                                </el-col>
                            </el-row>
                        </div>
                        <!--DEPOSIT STATUS PROJECT-->
                        <div class="history-item-block" v-if="item.action === 'depositProjectTaskCashAdvance' || item.action === 'depositProjectTaskCashAdvanceRequest'">
                            <el-row>
                                <el-col :span="6">
                                    <el-tag type="warning" size="small">Deposit</el-tag>
                                </el-col>
                                <el-col :span="10">
                                    {{moment(item.createDate.toString(), 'X').format('lll')}}
                                </el-col>
                            </el-row>
                        </div>
                        <!--DEPOSIT STATUS PROJECT-->
                        <div class="history-item-block" v-if="item.action === 'receiveProjectTaskCashAdvance' || item.action === 'receiveProjectTaskCashAdvanceRequest'">
                            <el-row>
                                <el-col :span="6">
                                    <el-tag type="primary" size="small">Received</el-tag>
                                </el-col>
                                <el-col :span="10">
                                    {{moment(item.createDate.toString(), 'X').format('lll')}}
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </div>
            </div>
        </sweet-modal>
        <sweet-modal v-on:close="rejectConfirmClose"  blocking class="nested" ref="rejectConfirm">
            <h1 class="modal__title">Reason</h1>
            <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="Description"
                    v-model="description">
            </el-input>
            <el-row :span="24" class="modal__bottom">
                <el-button
                        size="mini"
                        type="danger"
                        plain
                        @click="handleReject(activeCompanyId, activeProjectId, activeTaskId, activeCashAdvanceId, state)">Reject</el-button>
            </el-row>
        </sweet-modal>
        <sweet-modal ref="expenseNotFound" icon="warning">
            <div class="task-not-found-block">
                <h3>Cash Advance has been deleted</h3>
            </div>
        </sweet-modal>
        <!-- <sweet-modal class="nested" ref="nestedChild">
            <iframe class="iframe" :src="'https://docs.google.com/gview?url=' + fileUrl + '&embedded=true'" frameborder="0"></iframe>
        </sweet-modal> -->
        <div v-if="viewerType == 1">
            <sweet-modal blocking v-if="viewerType == 1" ref="nestedChild">
                <iframe class="iframe" :src="fileUrl" frameborder="0"></iframe>
            </sweet-modal>
        </div>
        <div v-if="viewerType == 2">
            <div v-show="false" class="images" v-viewer="{movable: true}">
                <img :src="fileUrl" :key="fileUrl" />
            </div>
        </div>
        <div class="mod" v-if="viewerType == 3">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'video'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
        <div class="mod" v-if="viewerType == 4">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'audio'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
    </div>
</template>

<script>
  let moment = require('moment')
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import Media from '@dongido/vue-viaudio'

  import axios from 'axios'
  export default {
    name: 'expenseInfo',
    components: {
      SweetModal,

      Media
    },
    data(){
      return{
        state: '',
        description: '',
        cashAdvanceNoModal: '',
        activeCompanyId: '',
        activeProjectId: '',
        activeTaskId: '',
        activeCashAdvanceId: '',
        activeNotificationId: '',
        moment:moment,
        cashAdvanceStatusModal: '',
        cashAdvanceDateModal: '',
        cashAdvanceInventoryItemModal: '',
        cashAdvanceAmountModal: '',
        // expenseReimbursableModal: '',
        // expenseisBillableModal: '',
        // expenseVendorModal:'',
        cashAdvanceClientModal:'',
        cashAdvancePaymentMethodModal: '',
        // expenseTaxModal:'',
        cashAdvanceProjectModal: '',
        cashAdvanceProjectTaskModal:'',
        cashAdvanceGroupModal:'',
        // expenseVendorTaxNumberModal:'',
        cashAdvanceNotesModal:'',
        cashAdvanceFileModal: '',
        fileUrl: '',
        type: '',
        viewerType: '',
        // fromHeader: false,
        projectTaskCashAdvanceHistoryList: [],
        isLeader: false,
        isAccountant: false,
        form:{
          paymentMethodList: [],
          paymentMethodId: ''
        },
        rules: {
          paymentMethodId: [
            { required: true,
              message: 'Field is required',
              trigger: 'blur' }
          ]
        }
      }
    },
    methods:{
      viewFile(url) {
        let type = url.split('.').pop().toUpperCase()
        if (type == 'STEP' || type == 'STP' || type == 'IGES' || type == 'IGS' || type == 'BREP' || type == 'STL' || type == 'SAT' || type == 'X_T' || type == 'X_B' || type == 'SLDPRT' || type == 'DWG' || type == 'DXF' || type == 'DWF' || type == 'HPGL' || type == 'PLT' || type == 'CGM' || type == 'SVG' || type == 'EMF' || type == 'WMF' || type == 'JPG' || type == 'JPEG' || type == 'PNG' || type == 'BMP' || type == 'OGG' || type == 'MP4' || type == 'WMA' || type == 'MP3' || type == 'WAV' || type == 'OGG' || type == 'M4A' || type == 'PDF') {
          this.fileUrl = url
          this.type = this.fileUrl.split('.').pop().toUpperCase()
          console.log('---', this.fileUrl, this.type);

          if (this.type == 'JPG' || this.type == 'JPEG' || this.type == 'PNG' || this.type == 'BMP') {
            this.viewerType = 2;
            setTimeout(() => {
              console.log('-----', this.$el);
              const viewer = this.$el.querySelector('.images').$viewer
              viewer.show()
            }, 300);
          } else if (this.type == 'OGG' || this.type == 'MP4') {
            this.viewerType = 3;
            setTimeout(() => {
              // this.$refs.video.open();
            }, 300);
          } else if (this.type == 'WMA' || this.type == 'MP3' || this.type == 'WAV' || this.type == 'OGG' || this.type == 'M4A') {
            this.viewerType = 4;
            setTimeout(() => {
              // this.$refs.video.open();
            }, 300);
          } else if (this.type == 'PDF') {
            this.viewerType = 1;
            this.fileUrl = process.env.VUE_APP_TF_PDF_VIEWER_BASE_URL + '/?file=' + this.fileUrl
            setTimeout(() => {
              // this.$refs.nestedChild.open();
              window.open(this.fileUrl);
            }, 300);
          } else if (this.type == 'STEP' || this.type == 'STP' || this.type == 'IGES' || this.type == 'IGS' || this.type == 'BREP' || this.type == 'STL' || this.type == 'SAT' || this.type == 'X_T' || this.type == 'X_B' || this.type == 'SLDPRT' || this.type == 'DWG' || this.type == 'DXF' || this.type == 'DWF' || this.type == 'HPGL' || this.type == 'PLT' || this.type == 'CGM' || this.type == 'SVG' || this.type == 'EMF' || this.type == 'WMF') {
            // this.viewerType = 1;
            this.fileUrl = 'https://sharecad.org/cadframe/load?url=' + this.fileUrl
            setTimeout(() => {
              // this.$refs.nestedChild.open();
              window.open(this.fileUrl);
            }, 300);
          }
        }
      },
      openModalInfo(companyId, projectId, projectTaskId, projectTaskCashAdvanceId, state){
        // alert('kel')
        this.activeCompanyId = companyId
        this.activeProjectId = projectId
        this.activeTaskId = projectTaskId
        this.activeCashAdvanceId = projectTaskCashAdvanceId
        this.state = state
        // this.fromHeader = true
        this.openModal(companyId, projectId, projectTaskId, projectTaskCashAdvanceId, state)
      },
      openModal(companyId, projectId, projectTaskId, projectTaskCashAdvanceId, state){
        let stateProjectId = ''
        let stateTaskId = ''
        let stateCashAdvanceId = ''
        switch (state){
          case 'projectTasksCashAdvance':
            stateProjectId = 'projectId'
            stateTaskId = 'projectTaskId'
            stateCashAdvanceId = 'projectTaskCashAdvanceId'
            break;
          case 'engagementTasksCashAdvance':
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateCashAdvanceId = 'engagementTaskCashAdvanceId'
            break;
          case 'businessUnitTasksCashAdvance':
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateCashAdvanceId = 'businessUnitTaskCashAdvanceId'
            break;
          case 'requestProjectTasksCashAdvance':
            stateProjectId = 'projectId'
            stateTaskId = 'projectTaskId'
            stateCashAdvanceId = 'projectTaskCashAdvanceId'
            break;
          case 'requestEngagementTasksCashAdvance':
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateCashAdvanceId = 'engagementTaskCashAdvanceId'
            break;
          case 'requestBusinessUnitTasksCashAdvance':
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateCashAdvanceId = 'businessUnitTaskCashAdvanceId'
            break;
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${state}/info?companyId=${companyId}&${stateProjectId}=${projectId}&${stateTaskId}=${projectTaskId}&${stateCashAdvanceId}=${projectTaskCashAdvanceId}`)
          .then(response => {
            let date = response.data.info.projectTaskCashAdvance.cashAdvanceDate.toString()
            if (date.length < 8) {
              this.cashAdvanceDateModal = '0' + date
            } else {
              this.cashAdvanceDateModal = response.data.info.projectTaskCashAdvance.cashAdvanceDate.toString()
            }
            this.cashAdvanceNoModal = response.data.info.projectTaskCashAdvance.code
            this.cashAdvanceDateModal = moment(this.cashAdvanceDateModal, "ddmmyyyy").format("D MMM YY")
            console.log(this.cashAdvanceDateModal)
            if (response.data.info.projectTaskCashAdvance.status === 1) {
              this.cashAdvanceStatusModal = 'Pending'
            } else if (response.data.info.projectTaskCashAdvance.status === 2) {
              this.cashAdvanceStatusModal = 'Submited'
            } else if (response.data.info.projectTaskCashAdvance.status === 3) {
              this.cashAdvanceStatusModal = 'Approved'
            } else if (response.data.info.projectTaskCashAdvance.status === 4) {
              this.cashAdvanceStatusModal = 'Rejected'
            } else if (response.data.info.projectTaskCashAdvance.status === 5) {
              this.cashAdvanceStatusModal = 'Deposit'
            }else if (response.data.info.projectTaskCashAdvance.status === 6) {
              this.cashAdvanceStatusModal = 'Received'
            }
            this.cashAdvanceInventoryItemModal = response.data.info.projectTaskExpenseInventoryItem.name
            this.cashAdvanceAmountModal = response.data.info.projectTaskCashAdvance.amount
            this.cashAdvanceClientModal = response.data.info.projectTaskCashAdvance.companyClient.name
            if(response.data.info.projectTaskCashAdvance.projectTaskExpensePaymentMethod){
              this.cashAdvancePaymentMethodModal = response.data.info.projectTaskCashAdvance.projectTaskExpensePaymentMethod.name
            }
            this.cashAdvanceProjectModal = response.data.info.projectTaskCashAdvance.project.name
            if(response.data.info.projectTaskCashAdvance.projectTask){
              this.cashAdvanceProjectTaskModal = response.data.info.projectTaskCashAdvance.projectTask.name
            }
            this.cashAdvanceGroupModal = response.data.info.projectTaskCashAdvance.group
            this.cashAdvanceNotesModal = response.data.info.projectTaskCashAdvance.notes
            if(response.data.info.projectTaskCashAdvance.file){
              this.cashAdvanceFileModal = response.data.info.projectTaskCashAdvance.file
            }
            this.projectTaskCashAdvanceHistoryList = []
            if(response.data.info.projectTaskCashAdvance.projectTask === null){
              response.data.info.projectTaskCashAdvanceHistoryList.forEach(val => {
                if(val.projectHistory !== null){
                  this.projectTaskCashAdvanceHistoryList.push(val.projectHistory)
                }
              })
            }else{
              response.data.info.projectTaskCashAdvanceHistoryList.forEach(val => {
                if(val.projectTaskHistory !== null){
                  this.projectTaskCashAdvanceHistoryList.push(val.projectTaskHistory)
                }
              })
            }

            this.isLeader = response.data.info.isLeader
            this.isAccountant = response.data.info.isAccountant
            if(response.data.info.isAccountant){
              this.getDirectories(companyId, projectId, projectTaskId, projectTaskCashAdvanceId, state)
            }
            this.$refs.modalInfo.open()
          })
          .catch(error => {
            this.expenseNotFoundOpenModal()
            this.$emit('deleteNotification', this.activeNotificationId, 'deleteGeneral')
            console.log('An error occurred:', error);
          });
      },
      getDirectories(companyId, projectId, projectTaskId, projectTaskCashAdvanceId, state){
        const urlParts = this.buildUrl(state)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.state}/directories?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${projectId}&${urlParts.stateTaskId}=${projectTaskId || 0}`)
          .then(response => {
            this.form.paymentMethodList = response.data.projectTaskExpensePaymentMethod;
          }).catch(err => {
          console.log('---', err);
        })
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      handleApprove(companyId, activeProjectId, activeTaskId, activeCashAdvanceId, state){
        let stateProjectId = ''
        let stateTaskId = ''
        let stateCashAdvanceId = ''
        switch (state){
          case 'projectTasksCashAdvance':
            stateProjectId = 'projectId'
            stateTaskId = 'projectTaskId'
            stateCashAdvanceId = 'projectTaskCashAdvanceId'
            break;
          case 'engagementTasksCashAdvance':
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateCashAdvanceId = 'engagementTaskCashAdvanceId'
            break;
          case 'businessUnitTasksCashAdvance':
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateCashAdvanceId = 'businessUnitTaskCashAdvanceId'
            break;
          case 'requestProjectTasksCashAdvance':
            stateProjectId = 'projectId'
            stateTaskId = 'projectTaskId'
            stateCashAdvanceId = 'projectTaskCashAdvanceId'
            break;
          case 'requestEngagementTasksCashAdvance':
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateCashAdvanceId = 'engagementTaskCashAdvanceId'
            break;
          case 'requestBusinessUnitTasksCashAdvance':
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateCashAdvanceId = 'businessUnitTaskCashAdvanceId'
            break;
        }
        console.log(activeProjectId, activeTaskId, activeCashAdvanceId)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${state}/approve?companyId=${companyId}&${stateProjectId}=${activeProjectId}&${stateTaskId}=${activeTaskId}&${stateCashAdvanceId}=${activeCashAdvanceId}`)
          .then(response => {
            this.$emit('deleteNotification', this.activeNotificationId)
            if(this.$route.name === 'cash-advances' && companyId == this.$route.query.companyId || this.$route.name === 'users' && companyId == this.$route.query.companyId){
              this.$emit('refreshCashAdvancePage', activeProjectId)
            }
            this.notification("Success", "CashAdvance Approved", "success");
            this.$refs.modalInfo.close()
          }).catch(error =>{
        })
      },
      handleReject(companyId, activeProjectId, activeTaskId, activeCashAdvanceId, state){
        let data = {
          description: this.description
        }
        console.log(activeProjectId, activeTaskId, activeCashAdvanceId)
        let stateProjectId = ''
        let stateTaskId = ''
        let stateCashAdvanceId = ''
        switch (state){
          case 'projectTasksCashAdvance':
            stateProjectId = 'projectId'
            stateTaskId = 'projectTaskId'
            stateCashAdvanceId = 'projectTaskCashAdvanceId'
            break;
          case 'engagementTasksCashAdvance':
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateCashAdvanceId = 'engagementTaskCashAdvanceId'
            break;
          case 'businessUnitTasksCashAdvance':
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateCashAdvanceId = 'businessUnitTaskCashAdvanceId'
            break;
          case 'requestProjectTasksCashAdvance':
            stateProjectId = 'projectId'
            stateTaskId = 'projectTaskId'
            stateCashAdvanceId = 'projectTaskCashAdvanceId'
            break;
          case 'requestEngagementTasksCashAdvance':
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateCashAdvanceId = 'engagementTaskCashAdvanceId'
            break;
          case 'requestBusinessUnitTasksCashAdvance':
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateCashAdvanceId = 'businessUnitTaskCashAdvanceId'
            break;
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${state}/reject?companyId=${companyId}&${stateProjectId}=${activeProjectId}&${stateTaskId}=${activeTaskId}&${stateCashAdvanceId}=${activeCashAdvanceId}`, data)
          .then(response => {
            this.$emit('deleteNotification', this.activeNotificationId)
            if(this.$route.name === 'cash-advances' && companyId == this.$route.query.companyId || this.$route.name === 'users' && companyId == this.$route.query.companyId){
              this.$emit('refreshCashAdvancePage', activeProjectId)
            }
            this.notification("Success", "Cash Advance Rejected", "success");
            this.$refs.rejectConfirm.close()
            this.rejectConfirmCloseMain()
          }).catch(error =>{
        })
      },
      handleDeposit(companyId, activeProjectId, activeTaskId, activeCashAdvanceId, state){
        this.$refs['form'].validate((valid) => {
          if (valid) {
            let stateProjectId = ''
            let stateTaskId = ''
            let stateCashAdvanceId = ''
            switch (state){
              case 'projectTasksCashAdvance':
                stateProjectId = 'projectId'
                stateTaskId = 'projectTaskId'
                stateCashAdvanceId = 'projectTaskCashAdvanceId'
                break;
              case 'engagementTasksCashAdvance':
                stateProjectId = 'engagementId'
                stateTaskId = 'engagementTaskId'
                stateCashAdvanceId = 'engagementTaskCashAdvanceId'
                break;
              case 'businessUnitTasksCashAdvance':
                stateProjectId = 'businessUnitId'
                stateTaskId = 'businessUnitTaskId'
                stateCashAdvanceId = 'businessUnitTaskCashAdvanceId'
                break;
              case 'requestProjectTasksCashAdvance':
                stateProjectId = 'projectId'
                stateTaskId = 'projectTaskId'
                stateCashAdvanceId = 'projectTaskCashAdvanceId'
                break;
              case 'requestEngagementTasksCashAdvance':
                stateProjectId = 'engagementId'
                stateTaskId = 'engagementTaskId'
                stateCashAdvanceId = 'engagementTaskCashAdvanceId'
                break;
              case 'requestBusinessUnitTasksCashAdvance':
                stateProjectId = 'businessUnitId'
                stateTaskId = 'businessUnitTaskId'
                stateCashAdvanceId = 'businessUnitTaskCashAdvanceId'
                break;
            }
            console.log(activeProjectId, activeTaskId, activeCashAdvanceId)
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/${state}/deposit?projectTaskExpensePaymentMethodId=${this.form.paymentMethodId}&projectTaskCashAdvanceId=${this.activeCashAdvanceId}`)
              .then(response => {
                // this.$emit('deleteNotification', this.activeNotificationId)
                if(this.$route.name === 'cash-advances' && companyId == this.$route.query.companyId || this.$route.name === 'users' && companyId == this.$route.query.companyId){
                  this.$emit('refreshCashAdvancePage', activeProjectId)
                }
                this.notification("Success", "CashAdvance Deposit", "success");
                this.$refs.modalInfo.close()
              }).catch(error =>{
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },
      handleReceive(companyId, activeProjectId, activeTaskId, activeCashAdvanceId, state){
            let stateProjectId = ''
            let stateTaskId = ''
            let stateCashAdvanceId = ''
            switch (state){
              case 'projectTasksCashAdvance':
                stateProjectId = 'projectId'
                stateTaskId = 'projectTaskId'
                stateCashAdvanceId = 'projectTaskCashAdvanceId'
                break;
              case 'engagementTasksCashAdvance':
                stateProjectId = 'engagementId'
                stateTaskId = 'engagementTaskId'
                stateCashAdvanceId = 'engagementTaskCashAdvanceId'
                break;
              case 'businessUnitTasksCashAdvance':
                stateProjectId = 'businessUnitId'
                stateTaskId = 'businessUnitTaskId'
                stateCashAdvanceId = 'businessUnitTaskCashAdvanceId'
                break;
              case 'requestProjectTasksCashAdvance':
                stateProjectId = 'projectId'
                stateTaskId = 'projectTaskId'
                stateCashAdvanceId = 'projectTaskCashAdvanceId'
                break;
              case 'requestEngagementTasksCashAdvance':
                stateProjectId = 'engagementId'
                stateTaskId = 'engagementTaskId'
                stateCashAdvanceId = 'engagementTaskCashAdvanceId'
                break;
              case 'requestBusinessUnitTasksCashAdvance':
                stateProjectId = 'businessUnitId'
                stateTaskId = 'businessUnitTaskId'
                stateCashAdvanceId = 'businessUnitTaskCashAdvanceId'
                break;
            }
            console.log(activeProjectId, activeTaskId, activeCashAdvanceId)
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/${state}/receive?&projectTaskCashAdvanceId=${this.activeCashAdvanceId}`)
              .then(response => {
                // this.$emit('deleteNotification', this.activeNotificationId)
                if(this.$route.name === 'cash-advances' && companyId == this.$route.query.companyId || this.$route.name === 'users' && companyId == this.$route.query.companyId){
                  this.$emit('refreshCashAdvancePage', activeProjectId)
                }
                this.notification("Success", "CashAdvance Received", "success");
                this.$refs.modalInfo.close()
              }).catch(error =>{
            })
      },
      expenseNotFoundOpenModal(){
        this.$refs.expenseNotFound.open()
        setTimeout(() => {
          this.$refs.expenseNotFound.close()
        }, 2000)
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      rejectConfirmClose(){
        this.description = ''
      },
      rejectConfirmCloseMain(){
        this.$refs.modalInfo.close()
      },
      rejectConfirmCloseInfoModal(){
        this.description =  '';
        this.cashAdvanceNoModal = '';
        this.cashAdvanceStatusModal = '';
        this.cashAdvanceDateModal = '';
        this.cashAdvanceInventoryItemModal = '';
        this.cashAdvanceAmountModal = '';
        // this.expenseReimbursableModal = '';
        // this.expenseisBillableModal = '';
        // this.expenseVendorModal = '';
        this.cashAdvanceClientModal = '';
        this.cashAdvancePaymentMethodModal=  '';
        // this.expenseTaxModal = '';
        this.cashAdvanceProjectModal = '';
        this.cashAdvanceProjectTaskModal = '';
        this.cashAdvanceGroupModal = '';
        // this.expenseVendorTaxNumberModal = '';
        this.cashAdvanceNotesModal = '';
        this.cashAdvanceFileModal = '';
        this.form.paymentMethodId = '';
        this.isLeader = false;
        this.isAccountant = false;
      },
      buildUrl(state) {
        let stateProjectId = ''
        let stateTaskId = ''
        let stateCashAdvanceId = ''
        let routeName = ''
        let labelName = ''
        // switch (advanceTab) {
        //   case 'tasksCashAdvance':
        switch (state){
          case 'projectTasksCashAdvance':
            stateProjectId = 'projectId'
            stateTaskId = 'projectTaskId'
            stateCashAdvanceId = 'projectTaskCashAdvanceId'
            routeName = 'projects'
            labelName = 'Projects'
            state = 'requestProjectTasksCashAdvance'
            break;
          case 'engagementTasksCashAdvance':
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateCashAdvanceId = 'engagementTaskCashAdvanceId'
            routeName = 'engagements'
            labelName = 'Engagements'
            state = 'requestEngagementTasksCashAdvance'
            break;
          case 'businessUnitTasksCashAdvance':
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateCashAdvanceId = 'businessUnitTaskCashAdvanceId'
            routeName = 'businessUnits'
            labelName = 'Business Units'
            state = 'requestBusinessUnitTasksCashAdvance'
            break;
        }

        return { state: state, stateProjectId: stateProjectId, stateTaskId: stateTaskId, stateCashAdvanceId: stateCashAdvanceId, routeName: routeName, labelName: labelName}
      },
    }
  }
</script>

<style lang="less" scoped>
    .modal__title{
        border-bottom: 1px solid #EBEEF5;
        padding-bottom: 10px;
    }
    .modal__amount{
        border-bottom: 1px solid #EBEEF5;
        padding-bottom: 10px;
    }
    .modal__bottom{
        margin-top:20px;
    }
    .task-not-found-block{
        text-align:center;
    }
    .history-item-block{
        padding-top: 10px;
        padding-bottom: 10px;
        border-top: 1px solid #EBEEF5;
        border-bottom: 1px solid #EBEEF5;
    }
    .modal__history_btn_block{
        margin-top:20px;
    }
    .iframe{
        width:640px;
        height:700px;
    }
</style>
